const apiBase = `${process.env.REACT_APP_ENERGY_DASHBOARD_API_URL}/api`;

export const crremUrls = {
  allScenarios: (projectId: string) => `${apiBase}/projects/${projectId}/crrem/dashboard/all-scenarios`,
  energyInputTemplate: `${apiBase}/crrem/energy-input/template`,
  energyInputUpload: (projectId: string) => `${apiBase}/projects/${projectId}/crrem/energy-input/upload`,
  subsetDownload: (projectId: string) => `${apiBase}/projects/${projectId}/crrem/subset/download`,
  subsetOverrides: (projectId: string) => `${apiBase}/projects/${projectId}/crrem/subset/overrides`,
  subsetUpload: (projectId: string) => `${apiBase}/projects/${projectId}/crrem/subset/upload`,
};
